/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Folder_Priority_ErrorInputs */



/**
* | output |
* | --- |
* | "Could not update the folder's embedding priority." |
*
* @param {Spaces_Folder_Priority_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_folder_priority_error = /** @type {((inputs?: Spaces_Folder_Priority_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Folder_Priority_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Einbettungspriorität des Ordners konnte nicht aktualisiert werden.")
	return /** @type {LocalizedString} */ ("Could not update the folder's embedding priority.")
});